const features = [
  {
    icon: 'ri-vidicon-line',
    title: '高清视频课程',
    description: '采用专业级高清录制设备，名师精心讲授，画面清晰流畅，让您在家也能享受沉浸式学习体验。',
  },
  {
    icon: 'ri-live-line',
    title: '名师直播辅导',
    description: '资深教师在线直播答疑，实时互动解惑，每周末定期开展专题辅导，确保学习效果。',
  },
  {
    icon: 'ri-time-line',
    title: '灵活学习方案',
    description: '课程支持随时随地学习，电脑手机多端同步，充分利用碎片化时间，工作学习两不误。',
  },
  {
    icon: 'ri-award-line',
    title: '国家认可学历',
    description: '合作高校均为教育部备案正规院校，所获学历国家承认，学信网终身可查，含金量有保障。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            专注成人学历教育多年，用专业和品质服务每一位学员
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}